/**
 * Portfolio configuration with explicit Tailwind classes
 */
export const PORTFOLIO_CONFIG = Object.freeze({
  7: { 
    name: 'orange', 
    color: '#fb923c', 
    classes: {
      container: 'portfolio-orange',
      inner: 'bg-orange-500',
    }
  },
  8: { 
    name: 'teal', 
    color: '#2dd4bf',
    classes: {
      container: 'portfolio-teal', 
      inner: 'bg-teal-400',
    }
  },
  default: { 
    name: 'blue', 
    color: '#3366FF',
    classes: {
      container: 'portfolio-blue',
      inner: 'bg-blue-600',
    }
  }
});

/**
 * Special portfolios requiring enhanced UI treatment
 */
export const SPECIAL_PORTFOLIOS = Object.freeze(
  new Set(['innovation', 'water saving'])
);

/**
 * Portfolio icon mappings
 */
export const PORTFOLIO_ICONS = Object.freeze({
  innovation: '/images/icons/innovation-icon.svg',
  'water saving': '/images/icons/water-saving.svg',
  process: '/images/icons/stacks.svg',
});

/**
 * Application constants
 */
export const APP_CONSTANTS = Object.freeze({
  FALLBACK_IMAGE: '/images/layout/placeholder.jpeg',
  SOLUTIONS_LAYER: 'key-solutions',
  ALL_PORTFOLIO: 'all',
  DEFAULT_PORTFOLIO_ID: 1,
});